import React from "react";
import Card from "../../components/page/Card";
import { hoje, mesAtual } from "../../helpers/mesesHelper";
import DocumentosFiltros from "./DocumentosMensais/DocumentosFiltros";
import TabList from "../../components/Tab/TabList";
import TabButton from "../../components/Tab/TabButton";
import TabPane from "../../components/Tab/TabPane";
import TabContent from "../../components/Tab/TabContent";
import DocumentosObrigatoriosDataTable from "./DocumentosMensais/DocumentosObrigatoriosDataTable";
import DocumentosAdicionaisDataTable from "./DocumentosMensais/DocumentosAdicionaisDataTable";
import { AppContext } from "../../contexts/AppContext";
import useApi from "../../hooks/useApi";
import DocumentosApiClient from "../../api/documentos";
import AdicionarArquivoModal from "./DocumentosMensais/AdicionarArquivoModal";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import CommonSwal from "../../components/Swal/commonSwal";
import DocumentosUploadModal from "./DocumentosMensais/DocumentosUploadModal";
import CommonsApiClient from "../../api/commons";
import DocumentoModal from "../../components/Common/DocumentoModal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import PeriodoPersonalizadoModal from "./DocumentosMensais/PeriodoPersonalizadoModal";

function DocumentosMensais() {
  const [filtros, setFiltros] = React.useState({
    mes: mesAtual,
    ano: hoje.getFullYear(),
  });
  const [documentosObrigatorios, setDocumentosObrigatorios] = React.useState(
    []
  );
  const [documentosAdicionais, setDocumentosAdicionais] = React.useState([]);
  const [adicionarArquivoModal, setAdicionarArquivoModal] =
    React.useState(false);
  const [uploadArquivoModal, setUploadArquivoModal] = React.useState(false);
  const [documentoModal, setDocumentoModal] = React.useState(false);
  const [substituir, setSubstituir] = React.useState(false);
  const [periodoPersonalizadoModal, setPeriodoPersonalizadoModal] =
    React.useState(false);
  const [values, setValues] = React.useState({});
  const [previews, setPreviews] = React.useState([]);
  const [tipo, setTipo] = React.useState(1);
  const { session } = React.useContext(AppContext);

  const getDocumentosCb = React.useCallback(
    (mes = null, ano = null) => {
      return DocumentosApiClient.getDocumentosMensais(
        session.empresa.replace(/E/gi, ""),
        {
          mes: mes ? mes : filtros.mes,
          ano: ano ? ano : filtros.ano,
        }
      );
    },
    [filtros.ano, filtros.mes, session.empresa]
  );
  const getDocumentosAdicionaisCb = React.useCallback(
    (mes = null, ano = null) => {
      return DocumentosApiClient.getDocumentosAdicionais(
        session.empresa.replace(/E/gi, ""),
        {
          mes: mes ? mes : filtros.mes,
          ano: ano ? ano : filtros.ano,
        }
      );
    },
    [filtros.ano, filtros.mes, session.empresa]
  );

  const { request: getDocumentosMensais, data: documentosMensaisResponse } =
    useApi(getDocumentosCb);
  const {
    request: getDocumentosAdicionais,
    data: documentosAdicionaisResponse,
  } = useApi(getDocumentosAdicionaisCb);
  const postDocumentosMensaisApi = useApi(
    DocumentosApiClient.postDocumentosMensais
  );
  const postDocumentosAdicionaisApi = useApi(
    DocumentosApiClient.postDocumentosAdicionais
  );
  const putDocumentosMensaisApi = useApi(
    DocumentosApiClient.putDocumentosMensais
  );
  const verificarPeriodoApi = useApi(DocumentosApiClient.verificarPeriodo);
  const postPeriodoPersonalizadoApi = useApi(
    DocumentosApiClient.postPeriodoPersonalizado
  );
  const deleteDocumentosAdicionaisApi = useApi(
    DocumentosApiClient.deleteDocumentosAdicionais
  );
  const documentoRouteApi = useApi(CommonsApiClient.documentoRoute);

  //Busca colaboradores ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getDocumentosMensais();
  }, [getDocumentosMensais, session.empresa]);

  //Busca colaboradores ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getDocumentosAdicionais();
  }, [getDocumentosAdicionais, session.empresa]);

  const getPrazo = (mes, ano) => {
    const selectedMonth = parseInt(mes) || mesAtual;
    const selectedYear = parseInt(ano) || hoje.getFullYear();

    return `10/${selectedMonth.toString().padStart(2, "0")}/${selectedYear}`;
  };

  //Define estado ao receber colaboradores
  React.useEffect(() => {
    if (!documentosMensaisResponse) return;

    const documentosBase = [
      {
        tipo_documento: "Extrato bancário",
        desc: "Conta PJ",
        prazo: getPrazo(filtros.mes, filtros.ano),
      },
    ];

    const documentosComercio = documentosMensaisResponse?.comercio
      ? [
          {
            tipo_documento: "Notas fiscais",
            desc: "NFe/NFCe/CTe",
            prazo: getPrazo(filtros.mes, filtros.ano),
          },
        ]
      : [];

    const arquivos = documentosMensaisResponse?.arquivos || [];
    const documentosMesclados = [...documentosBase, ...documentosComercio].map(
      (doc) => {
        const arquivo = arquivos.find(
          (a) => a.tipo_documento === doc.tipo_documento
        );
        return arquivo
          ? {
              ...doc,
              data_envio: arquivo.data_envio,
              caminho: arquivo.caminho,
              uid: arquivo.uid,
              id: arquivo.id,
              amazon: arquivo.amazon,
            }
          : doc;
      }
    );

    setDocumentosObrigatorios(documentosMesclados);
  }, [documentosMensaisResponse, filtros.ano, filtros.mes]);

  React.useEffect(() => {
    if (documentosAdicionaisResponse)
      setDocumentosAdicionais(documentosAdicionaisResponse);
  }, [documentosAdicionaisResponse]);

  const togAdicionarArquivoModal = () => {
    setAdicionarArquivoModal(true);
    setValues({});
    setPreviews([]);
  };

  const togUploadArquivoModal = (tipo) => {
    setUploadArquivoModal(true);
    setValues({});
    setTipo(tipo);
    setSubstituir(false);
  };

  const togSubstituirArquivoModal = (tipo) => {
    setUploadArquivoModal(true);
    setValues({});
    setTipo(tipo);
    setSubstituir(true);
  };

  const togPeriodoPersonalizadoModal = () => {
    setPeriodoPersonalizadoModal(true);
    setValues({
      data_final: `${filtros.ano}-${filtros.mes.toString().padStart(2, "0")}`,
    });
    setTipo(1);
  };

  const uploadDocumento = async () => {
    const formData = new FormData();
    formData.append("mes", filtros.mes);
    formData.append("ano", filtros.ano);
    formData.append("arquivo", values.arquivo);
    formData.append("tipo", tipo);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await postDocumentosMensaisApi.request(
      session.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    CommonSwal({
      icon: "success",
      title: "Documentos salvos com sucesso!",
    });
    setUploadArquivoModal(false);
    getDocumentosMensais();
  };

  const substituirDocumento = () => {
    OptionsSwal({
      title: "Confirma substituição?",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("mes", filtros.mes);
        formData.append("ano", filtros.ano);
        formData.append("arquivo", values.arquivo);
        formData.append("tipo", tipo);

        if (Validation.verificarForm(formData))
          return ErrorSwal({
            text: "Favor preencher todos os dados obrigatórios.",
          });

        const response = await putDocumentosMensaisApi.request(
          session.empresa.replace(/E/gi, ""),
          formData
        );
        if (!response) return;
        CommonSwal({
          icon: "success",
          title: "Documentos salvos com sucesso!",
        });
        setUploadArquivoModal(false);
        getDocumentosMensais();
      }
    });
  };

  const salvarDocumento = async () => {
    const formData = new FormData();
    formData.append("mes", filtros.mes);
    formData.append("ano", filtros.ano);

    if (!values.files || values.files.length === 0) {
      return ErrorSwal({
        text: "Favor adicionar arquivos para serem enviados.",
      });
    } else {
      values.files.forEach((file) => {
        formData.append("arquivos", file);
      });
    }

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await postDocumentosAdicionaisApi.request(
      session.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    CommonSwal({
      icon: "success",
      title: "Documentos salvos com sucesso!",
    });
    setAdicionarArquivoModal(false);
    getDocumentosAdicionais();
  };

  const downloadDocumento = async (caminho, ext) => {
    const response = await documentoRouteApi.request(caminho, {
      ext: ext,
      type: "download",
    });
    if (!response) return;
    const blob = new Blob([response]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${caminho}.${ext}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const visualizarDocumento = async (caminho) => {
    const response = await documentoRouteApi.request(caminho, {
      ext: "pdf",
      type: "visualizar",
    });
    if (!response) return;
    const pdfBlob = new Blob([response], { type: "application/pdf" });
    const documentUrl = URL.createObjectURL(pdfBlob);
    setValues({ documento: documentUrl });
    setDocumentoModal(true);
  };

  const setSemMovimentacao = async () => {
    OptionsSwal({
      title: "Confirmar ausência de movimentação?",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("mes", filtros.mes);
        formData.append("ano", filtros.ano);
        formData.append("arquivo", "-");
        formData.append("tipo", 2);

        if (Validation.verificarForm(formData))
          return ErrorSwal({
            text: "Favor preencher todos os dados obrigatórios.",
          });

        const response = await postDocumentosMensaisApi.request(
          session.empresa.replace(/E/gi, ""),
          formData
        );
        if (!response) return;
        CommonSwal({
          icon: "success",
          title: "Ausência de movimentação confirmada!",
        });
        setUploadArquivoModal(false);
        getDocumentosMensais();
      }
    });
  };

  const uploadPeriodoPersonalizado = async () => {
    const formData = new FormData();
    formData.append("inicio", values.data_inicial);
    formData.append("fim", values.data_final);
    formData.append("arquivo", values.arquivo);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await postPeriodoPersonalizadoApi.request(
      session.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    CommonSwal({
      icon: "success",
      title: "Documentos salvos com sucesso!",
    });
    setPeriodoPersonalizadoModal(false);
    getDocumentosMensais();
  };

  const verificarPeriodo = async () => {
    const formData = new FormData();
    formData.append("inicio", values.data_inicial);
    formData.append("fim", values.data_final);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await verificarPeriodoApi.request(
      session.empresa.replace(/E/gi, ""),
      {
        inicio: values.data_inicial,
        fim: values.data_final,
      }
    );
    if (!response) return;
    if (response?.text)
      OptionsSwal({
        icon: "warning",
        title: response.text,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Substituir tudo",
        denyButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          uploadPeriodoPersonalizado();
        }
      });
    else uploadPeriodoPersonalizado();
  };

  const excluirDocumento = (uid) => {
    OptionsSwal({
      title: "Confirma exclusão deste arquivo?",
    }).then(async (response) => {
      if (response.isConfirmed) {
        const response = await deleteDocumentosAdicionaisApi.request(
          session.empresa.replace(/E/gi, ""),
          { uid }
        );
        if (!response) return;
        CommonSwal({
          icon: "success",
          title: "Documento excluído com sucesso!",
        });
        getDocumentosAdicionais();
      }
    });
  };

  return (
    <>
      <div className="row">
        <Card>
          <DocumentosFiltros filtrosHook={{ filtros, setFiltros }} />
          <TabList>
            <TabButton href="documentos_obrigatorios" ativo>
              Documentos obrigatórios
            </TabButton>
            <TabButton href="documentos_adicionais">
              Documentos adicionais
            </TabButton>
          </TabList>
          <TabContent>
            <TabPane id="documentos_obrigatorios" ativo>
              <DocumentosObrigatoriosDataTable
                linhas={documentosObrigatorios}
                togUploadArquivoModal={togUploadArquivoModal}
                downloadDocumento={downloadDocumento}
                visualizarDocumento={visualizarDocumento}
                togSubstituirArquivoModal={togSubstituirArquivoModal}
                setSemMovimentacao={setSemMovimentacao}
                togPeriodoPersonalizadoModal={togPeriodoPersonalizadoModal}
              />
            </TabPane>
            <TabPane id="documentos_adicionais">
              <DocumentosAdicionaisDataTable
                linhas={documentosAdicionais}
                togAdicionarArquivoModal={togAdicionarArquivoModal}
                downloadDocumento={downloadDocumento}
                excluirDocumento={excluirDocumento}
              />
            </TabPane>
          </TabContent>
        </Card>
      </div>
      <AdicionarArquivoModal
        modalHook={{ adicionarArquivoModal, setAdicionarArquivoModal }}
        valuesHook={{ values, setValues }}
        salvarDocumento={salvarDocumento}
        previewsHook={{ previews, setPreviews }}
      />
      <DocumentosUploadModal
        modalHook={{ uploadArquivoModal, setUploadArquivoModal }}
        valuesHook={{ values, setValues }}
        uploadDocumento={uploadDocumento}
        tipo={tipo}
        substituirDocumento={substituirDocumento}
        substituir={substituir}
      />
      <DocumentoModal
        modalHook={{ documentoModal, setDocumentoModal }}
        documento={values?.documento}
      />
      <PeriodoPersonalizadoModal
        modalHook={{ periodoPersonalizadoModal, setPeriodoPersonalizadoModal }}
        valuesHook={{ values, setValues }}
        uploadPeriodo={verificarPeriodo}
        filtrosHook={{ filtros, setFiltros }}
      />
    </>
  );
}

export default DocumentosMensais;
